export default "__VITE_ASSET__4cFFLZ5C__ 720w";